export default {
    IvaAvailability: {
        enableTimeBasedAvailability: false,
    },
};



// WEBPACK FOOTER //
// ./settings/iva-availability.ts